import React from 'react';
import SEO from '../components/seo/SEO';
import KtpnHero from '../components/promo/KtpnHero';
import KtpnCatalog from '../components/promo/KtpnCatalog';
import KtpnUsp from '../components/promo/KtpnUsp';
import KtpnSpecs from '../components/promo/KtpnSpecs';
import KtpnApplications from '../components/promo/KtpnApplications';
import KtpnContact from '../components/promo/KtpnContact';
import KtpnFaq from '../components/promo/KtpnFaq';
// Другие импорты для будущих блоков будут здесь

const KtpnPromoPage: React.FC = () => {
  return (
    <>
      <SEO 
        title="КТПН — комплектные трансформаторные подстанции под ключ | Проминнова"
        description="Производство КТПН от 25 до 4000 кВА. Сертифицированное оборудование под ГОСТ и ТР ТС. Срок поставки от 50 дней. Проектирование, сборка и доставка по России и СНГ. Запросите КП за 1 день."
        keywords="КТПН, комплектные трансформаторные подстанции, ктпн цена, купить ктпн, ктпн от производителя, подстанция под ключ"
      />
      
      <KtpnHero />
      <KtpnCatalog />
      <KtpnUsp />
      <KtpnSpecs />
      <KtpnApplications />
      <KtpnContact />
      <KtpnFaq />

      {/* Main content больше не нужен, все секции самодостаточны */}
    </>
  );
};

export default KtpnPromoPage; 